module.exports = __webpack_public_path__ + "img/image_38.96c49856.png";